import { Pipe, PipeTransform } from '@angular/core';
import { Banner } from '../Model/Banner.model';

@Pipe({
  name: 'bannerFilter',
  standalone: false
})
export class BannerFilterPipe implements PipeTransform {

  transform(banners: Banner[], searchTerm: string, field?: string): Banner[] {
    if (!banners || !searchTerm?.trim()) {
      return banners;
    }

    const lowerSearch = searchTerm.toLowerCase();

    return banners.filter(banner => {
      if (field && banner[field]) {
        return String(banner[field]).toLowerCase().includes(lowerSearch);
      }

      // fallback to all fields if no specific field is passed
      const searchableFields = [
        'bannerName',
        'channelName',
        'customerName',
        'groupName',
        'warehouseName',
        'counterpartName'
      ];

      return searchableFields.some(key =>
        String(banner[key as keyof Banner]).toLowerCase().includes(lowerSearch)
      );
    });
  }
}
